import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xttg6nwn4k: FaireBrandEntity = {
  token: "b_xttg6nwn4k",
  type: "brand",
  name: "SoapElenGlen",
  avatarUrl:
    "https://cdn.faire.com/fastly/16312ad3c8e017d3646d12c7a6ffcd63f2d147023868b1fb8d5bc7039b5321b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e0dc2c15907de75036ecc0d2ca22d7e9723dcea54ad36c3b9773b7ec36812351.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/16312ad3c8e017d3646d12c7a6ffcd63f2d147023868b1fb8d5bc7039b5321b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e0dc2c15907de75036ecc0d2ca22d7e9723dcea54ad36c3b9773b7ec36812351.jpeg",
  location: "Glendale, CA, USA",
  minimumOrderDollars: 180,
  rating: 4.9,
  reviewCount: 70,
  isTopShop: true,
  isInsider: true,
  description:
    "Meet Elen Glen Soap-Your Premium Provider!\n\nAt Elen Glen Soap, value for money is my mission. No matter what you are looking for, I am committed to providing you with everything you need, when you need it.\n\nMy customers love working with me because I produce cost-effective products with a fast turnaround. Come into the shop and start our business.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.589Z",
    importedBy: "entity-db-cli",
  },
};
